import * as React from 'react'
import { FC, useCallback, useState } from 'react'
import InvitationModal from 'views/offers/pages/show/components/invitation_modal'
import Company from 'entities/company'
import Group from 'entities/group'
import Offer from 'entities/offer'
import Recruiter from 'entities/recruiter'
import * as classnames from 'classnames/bind'
import styles from './open_invitation_modal_button.module.scss'

type PrimitiveProps = {
  deviceName: string
  contentId: number
  previewUrl: string
  isPreview: boolean
}

type OriginalProps = {
  introducer: Object | null
  company: Object
  offer: Object
  group: Object
  searchGroup: Group
  buttonFloating: boolean
} & PrimitiveProps

type OpenInvitationModalProps = {
  introducer: Recruiter | null
  company: Company
  offer: Offer
  group: Group
  searchGroup: Group
} & PrimitiveProps

const cx = classnames.bind(styles)
const convertPropsToJsProps = (props: OriginalProps): OpenInvitationModalProps => {
  return {
    ...props,
    introducer: props.introducer ? new Recruiter(props.introducer) : null,
    company: new Company(props.company),
    offer: new Offer(props.offer),
    group: new Group(props.group),
    searchGroup: new Group(props.searchGroup)
  }
}

export const OpenInvitationModalPropsContext = React.createContext<Partial<OpenInvitationModalProps>>({})

const Button: FC<{ className?: string; wrapperClassName?: string; onClick: () => void }> = ({
  className,
  onClick,
  wrapperClassName
}) => (
  <div className={wrapperClassName}>
    <button type="button" className={className} onClick={onClick}>
      {I18n.t('offers.pages.show.components.open_invitation_modal_button.button')}
    </button>
  </div>
)

// フルスクリーンサイズのiphoneの高さ、左から5.8インチ、6.1インチ、6.5インチの高さ
const fullScreenIphoneHeights = [812, 828, 896]

export const OpenInvitationModalButton: React.FC<OriginalProps> = props => {
  const { buttonFloating } = props
  const [isOpen, setIsOpen] = useState(false)
  const openModal = useCallback(() => setIsOpen(true), [])
  const closeModal = useCallback(() => setIsOpen(false), [])
  const jsProps = convertPropsToJsProps(props)
  const userAgent = window.navigator.userAgent
  const isIphoneApp = userAgent && userAgent.match(/^Refcome.*iphone.*iOS.*/)
  const screenHeight = window.parent.screen.height
  // フルスクリーンサイズのiPhoneか判断します
  const isFullScreenIphone = fullScreenIphoneHeights.includes(screenHeight)

  return (
    <OpenInvitationModalPropsContext.Provider value={jsProps}>
      <Button
        className={cx(styles.button, {
          floatingButton: buttonFloating,
          defaultButtonSp: !buttonFloating && props.deviceName !== 'pc',
          defaultButtonPc: !buttonFloating && props.deviceName === 'pc'
        })}
        wrapperClassName={cx({
          floatingButtonWrapper: buttonFloating && !isIphoneApp,
          floatingButtonWrapperForIphoneApp: buttonFloating && isIphoneApp && !isFullScreenIphone,
          floatingButtonWrapperForFullScreenIphoneApp: buttonFloating && isIphoneApp && isFullScreenIphone,
          defaultButtonWrapper: !buttonFloating
        })}
        onClick={openModal}
      />
      <InvitationModal show={isOpen} closeModal={closeModal} />
    </OpenInvitationModalPropsContext.Provider>
  )
}
